import script from "./OptionText.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionText.vue?vue&type=script&setup=true&lang=ts"

import "./OptionText.vue?vue&type=style&index=0&id=657bf61c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657bf61c"]])

export default __exports__